import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { compose, setPropTypes } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import { DndProvider } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import TouchBackend from 'react-dnd-touch-backend';
import update from 'immutability-helper';
import DragItem from '../atoms/DragItem';
import CustomDragLayer from '../atoms/CustomDragLayer';

const styles = {};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(setPropTypes(propTypes));

const Main = enhance(({ itemType, items, setOrderItems }) => {
  const isAndroid = () => {
    return !!window.navigator.userAgent.match(/Android/);
  };

  const isIOS = () => {
    return !!window.navigator.userAgent.match(/iPhone|iPad|iPod/);
  };

  const moveItem = useCallback(
    (toIndex, fromIndex) => {
      const dragItem = items[toIndex];
      setOrderItems(
        update(items, {
          $splice: [[toIndex, 1], [fromIndex, 0, dragItem]]
        })
      );
    },
    [items]
  );

  return (
    <DndProvider backend={isAndroid() || isIOS() ? TouchBackend : HTML5Backend}>
      {(isAndroid() || isIOS()) && <CustomDragLayer />}
      {items.map((item, index) => {
        return (
          <DragItem
            key={item.id}
            index={index}
            id={item.id}
            name={item.name}
            itemType={itemType}
            moveItem={moveItem}
          />
        );
      })}
    </DndProvider>
  );
});

export default withRouter(withStyles(styles)(Main));
